<script>
  import SmallTitle from '../../common/SmallTitle.svelte';
  import Partner from '../Partner.svelte';

  export let partners;
  export let lang = undefined;
  export let mode = undefined;

  const i18n = {
    generalPartner: {
      cs: 'Generální partner',
      en: 'General partner',
    },
    mainPartner: {
      cs: 'Hlavní partner',
      en: 'Main partner',
    },
    partners: {
      cs: 'Partneři',
      en: 'Partners',
    },
    mediaPartners: {
      cs: 'Mediální partneři',
      en: 'Media partners',
    },
  };

  const generalPartner = partners.find(partner => partner.type === 'general');
  const mainPartner = partners.find(partner => partner.type === 'main');

  const normalPartners = partners.filter(partner => partner.type === 'normal');
  const municipalityPartners = partners.filter(partner => partner.type === 'municipality');

  const mediaPartners = partners.filter(partner => partner.type === 'media');
</script>

{#if partners.length > 0}
  <div class='partners-box'>
    {#if generalPartner || mainPartner}
      <div class='partners-box-important'>
        {#if generalPartner}
          <div class='partners-box-important-general'>
            <div class='partners-box-important-general-small-title'>
              <SmallTitle value={i18n.generalPartner[lang]}/>
            </div>

            <div class='partners-box-important-general-partner'>
              <Partner value={generalPartner} big={true} bind:lang bind:mode/>
            </div>
          </div>
        {/if}

        {#if mainPartner}
          <div class='partners-box-important-main'>
            <div class='partners-box-important-main-small-title'>
              <SmallTitle value={i18n.mainPartner[lang]}/>
            </div>

            <div class='partners-box-important-main-partner'>
              <Partner value={mainPartner} big={true} bind:lang bind:mode/>
            </div>
          </div>
        {/if}
      </div>
    {/if}

    {#if normalPartners.length > 0 || municipalityPartners.length > 0}
      <div class='partners-box-normal-and-municipality'>
        <div class='partners-box-normal-and-municipality-small-title'>
          <SmallTitle value={i18n.partners[lang]}/>
        </div>

        {#if normalPartners.length > 0}
          <div class='partners-box-normal-and-municipality-normal-partners'>
            {#each normalPartners as normalPartner}
              <Partner value={normalPartner} bind:lang bind:mode/>
            {/each}
          </div>
        {/if}

        {#if municipalityPartners.length > 0}
          <div class='partners-box-normal-and-municipality-municipality-partners'>
            {#each municipalityPartners as municipalityPartner}
              <Partner value={municipalityPartner} bind:lang bind:mode/>
            {/each}
          </div>
        {/if}
      </div>
    {/if}

    {#if mediaPartners.length > 0}
      <div class='partners-box-media'>
        <div class='partners-box-media-small-title'>
          <SmallTitle value={i18n.mediaPartners[lang]}/>
        </div>

        <div class='partners-box-media-partners'>
          {#each mediaPartners as mediaPartner}
            <Partner value={mediaPartner} bind:lang bind:mode/>
          {/each}
        </div>
      </div>
    {/if}
  </div>
{/if}

<style>
  .partners-box {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .partners-box-important {
    display: flex;
    gap: 40px;
  }

  .partners-box-important-general {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;

    width: calc((100% - 40px) / 5 * 3);
  }

  .partners-box-important-main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;

    width: calc((100% - 40px) / 5 * 2);
  }

  .partners-box-normal-and-municipality, .partners-box-media {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .partners-box-normal-and-municipality-normal-partners,
  .partners-box-normal-and-municipality-municipality-partners,
  .partners-box-media-partners {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  @media only screen and (max-width: 1300px) {
    .partners-box-important {
      flex-direction: column;
    }

    .partners-box-important-general, .partners-box-important-main {
      width: 100%;
    }
  }
</style>
